/* global mockup:true */
/* eslint no-console: 0, no-unused-vars: 0, no-undef: 0, no-unused-expressions: 0 */
import Vue from 'vue'
import VueMoment from 'vue-moment'
import axios from '~/util/axios'
import Sentry from '~/util/sentry'
import Router from 'vue-router'
import Snackbard from 'snackbard'
import apolloClient from '~/util/apolloClient'
import vuetify from '~/util/vuetify'
import App from '~/components/signingRoomApp'
import icons from '~/util/icons'
import { store } from '../store/index'
import { VueMaskDirective } from 'v-mask'
import snSigningRoomService from '../services/snSigningRoomService'
import { ensureNcinoWebComponents } from '~/util/ncinoWebComponents'
import {
  snBanner,
  snHeader,
  snTabs,
  snCaptiveFlow,
  snGradientHeader,
  snTable,
  snTableColumnType,
  snAlert,
  snDatePicker,
  snExpansionPanel,
  snExpansionPanels,
  snSideMenu,
  snDataItem,
  snSidePanel,
  snModal,
  snStatus,
  snFileInput,
  snToaster,
  snToast,
  snAvatar,
  snIllustration,
  snSwitch,
  snChip,
  snCheckbox,
  snPdfViewer,
  snSelect,
  snAutocomplete,
  snCombobox,
  snRadio,
  snRadioGroup,
  snHeadlineCard,
  snLabel,
  snBtn,
  snBtnCard,
  snTooltip,
  snTextField,
  snTextarea,
  snPhotoUploader,
  snPassword,
  snDraggable,
  snBoolean
} from '@simplenexus/snui'
// eslint-disable-next-line import/no-unresolved
import '@simplenexus/snui/dist/assets/index.css'

import('~/assets/css/snIcons.css')
import('~/assets/stylesheets/signingRoomApp.scss')

ensureNcinoWebComponents()

if (['development', 'staging'].includes(process.env.RAILS_ENV)) {
  Vue.config.devtools = true
}

Vue.component('snBanner', snBanner)
Vue.component('snDatePicker', snDatePicker)
Vue.component('snHeader', snHeader)
Vue.component('snTabs', snTabs)
Vue.component('snCaptiveFlow', snCaptiveFlow)
Vue.component('snExpansionPanel', snExpansionPanel)
Vue.component('snExpansionPanels', snExpansionPanels)
Vue.component('snGradientHeader', snGradientHeader)
Vue.component('snSideMenu', snSideMenu)
Vue.component('snTable', snTable)
Vue.component('snTableColumnType', snTableColumnType)
Vue.component('snSidePanel', snSidePanel)
Vue.component('snAlert', snAlert)
Vue.component('snFileInput', snFileInput)
Vue.component('snDataItem', snDataItem)
Vue.component('snStatus', snStatus)
Vue.component('snModal', snModal)
Vue.component('snCheckbox', snCheckbox)
Vue.component('snChip', snChip)
Vue.component('snSwitch', snSwitch)
Vue.component('snToaster', snToaster)
Vue.component('snToast', snToast)
Vue.component('snAvatar', snAvatar)
Vue.component('snIllustration', snIllustration)
Vue.component('snPdfViewer', snPdfViewer)
Vue.component('snSelect', snSelect)
Vue.component('snAutocomplete', snAutocomplete)
Vue.component('snCombobox', snCombobox)
Vue.component('snRadio', snRadio)
Vue.component('snRadioGroup', snRadioGroup)
Vue.component('snHeadlineCard', snHeadlineCard)
Vue.component('snLabel', snLabel)
Vue.component('snBtn', snBtn)
Vue.component('snBtnCard', snBtnCard)
Vue.component('snTooltip', snTooltip)
Vue.component('snTextField', snTextField)
Vue.component('snTextarea', snTextarea)
Vue.component('snPhotoUploader', snPhotoUploader)
Vue.component('snPassword', snPassword)
Vue.component('snDraggable', snDraggable)
Vue.component('snBoolean', snBoolean)

const { VueApollo, provider } = apolloClient()

Vue.use(Router)
Vue.use(VueApollo)
Vue.use(VueMoment)
Vue.use(Snackbard)
Vue.use(vuetify, {
  options: {
    customProperties: true
  },
  icons: icons
})

Vue.directive('mask', VueMaskDirective)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: 'manager'
    },
    {
      path: '/portal',
      name: 'Portal',
      meta: { title: 'Signer portal' },
      component: () =>
        import('~/components/portal')
    },
    {
      path: '/portal/logged_out',
      name: 'Portal logged out',
      meta: { title: 'Signer portal session expired' },
      component: () =>
        import('~/components/portalLogout')
    },
    {
      path: '/manager',
      name: 'Manager Blank Page',
      component: () =>
        import('~/components/managerBlankPage')
    },
    {
      path: '/manager/consent/:guid',
      name: 'Consent',
      meta: { title: 'Consent' },
      component: () =>
        import('~/components/consent')
    },
    {
      path: '/manager/sessions',
      name: 'Signing sessions',
      meta: { title: 'Signing sessions' },
      component: () =>
        import('~/components/sessions')
    },
    {
      path: '/manager/sessions/:guid',
      name: 'Session Details',
      meta: { title: 'Session Details' },
      component: () =>
        import('~/components/sessionDetails')
    },
    {
      path: '/manager/settings',
      name: 'Settings',
      meta: { title: 'Signer room settings' },
      component: () =>
        import('~/components/companySettings')
    },
    {
      path: '/manager/reports',
      name: 'Reports',
      meta: { title: 'Signer room reports' },
      component: () =>
        import('~/components/reports')
    },
    {
      path: '/manager/dev_tools',
      name: 'DevTools',
      meta: { title: 'Signer room dev tools' },
      component: () =>
        import('~/components/devTools')
    },
    {
      path: '/manager/companies',
      name: 'Companies',
      meta: { title: 'Companies' },
      component: () =>
        import('~/components/companies')
    },
    {
      path: '/manager/companies/:guid',
      name: 'Company Details',
      meta: { title: 'Company Details' },
      component: () =>
        import('~/components/companyDetails')
    },
    {
      path: '/login',
      name: 'Login',
      meta: { title: 'Login' },
      component: () =>
        import('~/components/login')
    },
    {
      path: '/no_access/:entity',
      name: 'No Access',
      meta: { title: 'No access' },
      component: () => import('~/components/noAccess')
    },
    {
      path: '/manager/integrations',
      name: 'Integrations',
      meta: { title: 'Integrations' },
      component: () =>
        import('~/components/tables/apiClients/apiClientsTable')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'Page Not Found',
      meta: { title: 'Page not found' },
      component: () =>
        import('~/components/pageNotFound')
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const user = store.getters.user
  if (user == null || user.loading === true) {
    next()
  } else {
    const hasMersOrgId = !!store.getters.mersOrgId
    const canAccess = snSigningRoomService.canAccess(user, to.name, hasMersOrgId)
    if (!canAccess) {
      next({ path: snSigningRoomService.getDefaultPage(user, hasMersOrgId) })
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = `eSign - ${to.meta.title || 'nCino'}`
    window.scrollTo(0, 0)
  })
})

const formatDateTime = (value) => {
  if (!value) { return '' }
  return Vue.prototype.$moment(value).format('MMM D, YYYY [at] h:mmA').toString()
}
const formatDate = (value) => {
  if (!value) { return '' }
  return Vue.prototype.$moment(value).format('MMM D, YYYY').toString()
}
const formatTime = (value) => {
  if (!value) { return '' }
  return Vue.prototype.$moment(value).format('h:mm A').toString()
}
const formatInitials = (value) => {
  const initials = value?.split(' ')?.filter(i => i.length > 0)?.map((i) => i[0].toUpperCase()) || []
  if (initials.length > 1) {
    return `${initials[0]}${initials[initials.length - 1]}`
  } else if (initials.length === 1) {
    return `${initials[0]}`
  } else {
    return ''
  }
}

Vue.prototype.$sentry = Sentry([{ key: 'pack', value: 'Signing Room' }])
Vue.prototype.$axios = axios
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('formatDate', formatDate)
Vue.filter('formatTime', formatTime)
Vue.filter('initials', formatInitials)

Vue.mixin({
  methods: {
    formatDateTime: formatDateTime,
    formatDate: formatDate,
    formatTime: formatTime
  }
})

const app = new Vue({
  router,
  store,
  el: '#signingRoom',
  apolloProvider: provider,
  render: h => h(App),
  vuetify
})
